"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrlParser = void 0;
var tslib_1 = require("tslib");
var UrlParser = (function () {
    function UrlParser() {
        this.params = {};
    }
    UrlParser.prototype.parseUri = function () {
        var _this = this;
        var uri = window.location.search.substr(1);
        var partParams = uri.split("&");
        if (!partParams.length) {
            return;
        }
        partParams.forEach(function (item) {
            var _a = tslib_1.__read(item.split("="), 2), key = _a[0], value = _a[1];
            _this.params[key] = value;
        });
    };
    UrlParser.prototype.getParam = function (name) {
        if (typeof this.params[name] !== "undefined") {
            return this.params[name];
        }
        return null;
    };
    return UrlParser;
}());
exports.UrlParser = UrlParser;
//# sourceMappingURL=UrlParser.js.map